import { StyleRulesCallback, Theme, Typography, WithStyles, withStyles } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import { isDate, isNumber, required, Validator } from '../../../shared/validation';
import FormTextField from '../../../components/FormTextField';
import { Field } from 'redux-form';
import { BpM } from '../../../shared/brakepoints';
import FormSelectField from '../../../components/FormSelectField';
import Translator from '../../../components/Translator';
import { defaultMemoize } from 'reselect';

type CssClasses = 'fieldContainer' | 'fullRow' | 'bigRow';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  fieldContainer: {
    display: 'flex',
    flexFlow: 'column',
    '& > *': {
      flex: '0 0 100%',
    },
    [BpM()]: {
      display: 'flex',
      margin: '0px -5px 0px',
      width: '500px',
      flexFlow: 'row wrap',
      '& > *': {
        flex: '0 0 250px',
        paddingLeft: '5px',
        paddingRight: '5px',
        maxWidth: '250px',
      },
    },
  },
  fullRow: {
    flex: '0 0 100%',
    maxWidth: '100%',
  },
  bigRow: {
    flex: '0 0 100%',
    maxWidth: '100%',
    [BpM()]: {
      '& > *': {
        width: '320px',
        paddingRight: '10px',
      },
    },
  },
});

interface Props {}

class BankAccountDisclosureFormData extends React.Component<Props & WithStyles<CssClasses>> {
  private translatedRequire = defaultMemoize((translation: string) => {
    return required(translation);
  });

  private justRequired = defaultMemoize((requiredValidator: Validator) => {
    return [requiredValidator];
  });
  render() {
    let { classes } = this.props;
    return (
      <Translator>
        {translate => {
          const req = this.translatedRequire(translate('missing'));
          const justRequired = this.justRequired(req);
          return (
            <>
              <Typography variant={'h6'}>{translate('bankSectionTitle')}</Typography>

              <div className={classes.fieldContainer}>
                <div className={classes.bigRow}>
                  <Field
                    name="bankAccountOwner"
                    requireMark
                    component={FormTextField}
                    validate={justRequired}
                    label={translate('bankAccountOwner')}
                    fullWidth={true}
                  />
                </div>
                <div className={classes.bigRow}>
                  <Field
                    name="iban"
                    requireMark
                    component={FormTextField}
                    validate={justRequired}
                    label={translate('iban')}
                    fullWidth={true}
                  />
                </div>
              </div>
            </>
          );
        }}
      </Translator>
    );
  }
}

export default pure(withStyles(styles)(BankAccountDisclosureFormData));


// WEBPACK FOOTER //
// ./src/routes/disclosure/components/BankAccountDisclosureFormData.tsx